import React, { useCallback, useEffect, useRef } from 'react'
import AnimateHeight from 'react-animate-height'
import ReactDOM from 'react-dom'
import { useActions, useValues } from 'kea'

import logic from './logic'
import PortalContent from './portal-content'

const MAX_HEIGHT = 500

const How = () => {
  const howAreaRef = useRef(null)

  const { howIsOpen, renderHow } = useValues(logic)
  const { fastHide } = useActions(logic)

  const PORTAL_CONTAINER = typeof document !== 'undefined' ? document.getElementById('above-header') : null

  const handleScroll = useCallback(() => {
    if (typeof document !== 'undefined' && howIsOpen && howAreaRef && howAreaRef.current) {
      const howAreaHeight = howAreaRef.current.clientHeight
      const scroll = document.documentElement.scrollTop || document.body.scrollTop

      if (howAreaHeight > MAX_HEIGHT && scroll > howAreaHeight) {
        fastHide()
        if (document.documentElement.scrollTop) {
          document.documentElement.scrollTop -= howAreaHeight
        } else {
          document.body.scrollTop -= howAreaHeight
        }
      }
    }
  }, [fastHide, howIsOpen])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    renderHow &&
    ReactDOM.createPortal(
      <AnimateHeight duration={500} height={howIsOpen ? 'auto' : 0}>
        <PortalContent ref={howAreaRef} />
      </AnimateHeight>,
      PORTAL_CONTAINER
    )
  )
}

export default How
